import * as THREE from "three";
import { getGeometry } from "./loaders";
import type { SceneObjectData, Vec3 } from "../types";

/** Local-space bounding box size of the geometry (before transforms). */
export function getLocalSize(data: SceneObjectData): THREE.Vector3 {
  const geometry = getGeometry(data.id, data.fileBase64, data.format);
  if (!geometry.boundingBox) geometry.computeBoundingBox();
  const size = new THREE.Vector3();
  geometry.boundingBox!.getSize(size);
  return size;
}

/** Approximate world-space dimensions: local size scaled by the object's scale. */
export function getScaledSize(data: SceneObjectData): Vec3 {
  const local = getLocalSize(data);
  return [local.x * data.scale[0], local.y * data.scale[1], local.z * data.scale[2]];
}
